import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { t } from 'i18next';
import { SponsorListType } from '../hooks/use-sponsor-list';

const columnHelper = createColumnHelper<SponsorListType>();

export const sponsorColumns = [
  columnHelper.accessor((row) => row.name, {
    id: 'Oppdragsgiver',
    cell: (info) => {
      const value = info.getValue();
      const sponsorText = t(`oneWayIn:sponsors.${value}`);
      return <span>{sponsorText}</span>;
    },
  }),
];
